<app-header headerText="Ciclo de Inversión"></app-header>

<mat-tab-group mat-align-tabs="center" animationDuration="0ms" dynamicHeight=true [selectedIndex]="selectedIndex"
  (selectedTabChange)="tabChanged($event)">

  <mat-tab>

    <ng-template mat-tab-label>
      <mat-icon>edit</mat-icon>
      Editar Ciclo<br>De Inversión
    </ng-template>

    <div class="row py-2 border-bottom">

      <div class="col-md-4 offset-md-4">

        <mat-form-field>
          <mat-select placeholder="Nombre del Ciclo:" (selectionChange)="selectedPeriodChange($event)"
            [value]="tempPeriod">
            <mat-option>Seleccione el Ciclo</mat-option>
            <mat-option *ngFor="let period of savingParameters" [value]="period">
              {{period.title}}
            </mat-option>
          </mat-select>
        </mat-form-field>

      </div>

    </div>

    <div [ngClass]="{'blocked': !isEdit}">

      <div class="row pt-5" *ngIf="modParameter">

        <div class="col-md-6 col-xl-4 offset-md-2">
          <button [ngClass]="'btn btn-block'" [class.btn-primary]="contentLocation.savingParametersIndex === 0"
            [class.btn-outline-secondary]="contentLocation.savingParametersIndex !== 0" (click)="switchTo(0)">
            Asignar<br>Inversión
          </button>
        </div>

        <div class="col-md-6 mt-2 col-xl-4 mt-xl-0">
          <button [ngClass]="'btn btn-block'" [class.btn-primary]="contentLocation.savingParametersIndex === 1"
            [class.btn-outline-secondary]="contentLocation.savingParametersIndex !== 1" (click)="switchTo(1)">
            Liberación de<br>Préstamos
          </button>
        </div>        
      </div><br>

      <div class="p-3" *ngIf="contentLocation.savingParametersIndex == 0">
        <div class="row mt-5">

          <div class="col-md-4">
            <mat-form-field>
              <mat-select placeholder="Tipo de Cuenta:"
                (selectionChange)="selectedSaving($event);selectSavingPeriod($event)" >
                <mat-option>Seleccione el Tipo</mat-option>
                <mat-option *ngFor="let saver of savingAccount" [value]="saver">
                  {{saver.title}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="col-md-4" *ngIf="disabledSaving == true">
            <mat-form-field>
              <span matPrefix>$&nbsp;</span>
              <input matInput style="width:95%;" placeholder="Ajustes del Banco (Inversión):"
                [ngModel]="modParameter.investmentParameterSavers.bankAdjustment | number: '1.'"
                (ngModelChange)="modParameter.investmentParameterSavers.bankAdjustment=currencyInputChanged($event)"
                appOnlyNumber [allowDecimals]="true" type="text" type="string">
            </mat-form-field>
          </div>

          <div class="col-md-4" *ngIf="disabledSaving == false">
            <mat-form-field>
              <span matPrefix>$&nbsp;</span>
              <input matInput style="width:95%;" placeholder="Ajustes del Banco (Inversión):"
                [ngModel]="modParameter.investmentParameterNonSavers.bankAdjustment | number: '1.'"
                (ngModelChange)="modParameter.investmentParameterNonSavers.bankAdjustment=currencyInputChanged($event)"
                appOnlyNumber [allowDecimals]="true" type="text" type="string">
            </mat-form-field>
          </div>

        </div>
        <!-- div de parametros investmentParameterSavers-->
        <div *ngIf="disabledSaving == true">
          <div class="row" [ngClass]="{'blocked': false}">

            <div class="col-md-4">
              <mat-form-field>
                <span class="matPrefixDisabled" matPrefix>$&nbsp;</span>
                <input matInput placeholder="Reembolso:"
                  [value]="modParameter.investmentParameterSavers.refunds | number: '.2-2'" readonly>
              </mat-form-field>
            </div>

            <div class="col-md-4">
              <mat-form-field>
                <span class="matPrefixDisabled" matPrefix>$&nbsp;</span>
                <input matInput placeholder="Importe de Préstamo a Pagar:"
                  [value]="modParameter.investmentParameterSavers.loansRefundAmount | number: '.2-2'" readonly>
              </mat-form-field>
            </div>

            <div class="col-md-4">
              <mat-form-field>
                <span class="matPrefixDisabled" matPrefix>$&nbsp;</span>
                <input matInput placeholder="Monto Teórico Disponible:"
                  [value]="modParameter.investmentParameterSavers.theoreticalAvailableAmount | number: '.2-2'" readonly>
              </mat-form-field>
            </div>

          </div>

          <div class="row mt-5">

            <div class="col-md-4">
              <mat-form-field>
                <input matInput [matDatepicker]="inicioDeCicloPickerSavers" placeholder="Inicio De Ciclo:"
                  (dateChange)="setCycleDateSavers('starts', $event)" [value]="newRLoanDateSavers.startDate">
                <mat-datepicker-toggle matSuffix [for]="inicioDeCicloPickerSavers"></mat-datepicker-toggle>
                <mat-datepicker #inicioDeCicloPickerSavers></mat-datepicker>
              </mat-form-field>
            </div>

            <div class="col-md-4">
              <mat-form-field>
                <input matInput [matDatepicker]="finDeCicloPickerSavers" placeholder="Fin De Ciclo:"
                  (dateChange)="setCycleDateSavers('ends', $event)" [value]="newRLoanDateSavers.endDate"
                  [min]="newRLoanDateSavers.startDate" [disabled]="!newRLoanDateSavers.endDate">
                <mat-datepicker-toggle matSuffix [for]="finDeCicloPickerSavers"></mat-datepicker-toggle>
                <mat-datepicker #finDeCicloPickerSavers [disabled]="!newRLoanDateSavers.endDate"></mat-datepicker>
              </mat-form-field>
            </div>

            <div class="col-md-4 bottom-vertically">
              <button class="btn btn-block btn-primary" (click)="addDateSavers()">Añadir</button>
            </div>

          </div>

          <div class="my-5 row border-top" *ngIf="modParameter.investmentParameterSavers.investmentDates.length > 0">
            <div class="col-md-12">

              <mat-table #investmentsDatesTable class="table"
                [dataSource]="modParameter.investmentParameterSavers.investmentDates">

                <ng-container matColumnDef="InicioInversion">
                  <mat-header-cell *matHeaderCellDef> Inicio De Inversion</mat-header-cell>
                  <mat-cell *matCellDef="let element"> {{element.startDate | date: 'mediumDate'}} </mat-cell>
                </ng-container>

                <ng-container matColumnDef="FinInversion">
                  <mat-header-cell *matHeaderCellDef> Fin De Inversion </mat-header-cell>
                  <mat-cell *matCellDef="let element"> {{element.endDate ? (element.endDate | date: 'mediumDate') :
                        ''}}</mat-cell>
                </ng-container>

                <ng-container matColumnDef="active">
                  <mat-header-cell *matHeaderCellDef> Fecha Activa </mat-header-cell>
                  <mat-cell *matCellDef="let element">
                    <mat-checkbox (change)="calculateInvestment()" [(ngModel)]="element.active" [disabled]="false">Fecha
                      Activa</mat-checkbox>
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="delete" class="center-text">
                  <mat-header-cell *matHeaderCellDef><span>Eliminar</span></mat-header-cell>
                  <mat-cell *matCellDef="let index = index">
                    <button mat-icon-button color="warn" (click)="deleteDate(index)">
                      <mat-icon aria-label="Delete">delete_outline</mat-icon>
                    </button>

                  </mat-cell>
                </ng-container>

                <mat-header-row mat-header-row *matHeaderRowDef="displayedLoanDatesColumns"></mat-header-row>
                <mat-row mat-row *matRowDef="let row; columns: displayedLoanDatesColumns;"></mat-row>

              </mat-table>

            </div>
          </div>
        </div>
        <!-- div de parametros investmentParameterNonSavers-->
        <div *ngIf="disabledSaving == false">
          <div class="row" [ngClass]="{'blocked': false}">

            <div class="col-md-4">
              <mat-form-field>
                <span class="matPrefixDisabled" matPrefix>$&nbsp;</span>
                <input matInput placeholder="Reembolso:"
                  [value]="modParameter.investmentParameterNonSavers.refunds | number: '.2-2'" readonly>
              </mat-form-field>
            </div>

            <div class="col-md-4">
              <mat-form-field>
                <span class="matPrefixDisabled" matPrefix>$&nbsp;</span>
                <input matInput placeholder="Importe de Préstamo a Pagar:"
                  [value]="modParameter.investmentParameterNonSavers.loansRefundAmount | number: '.2-2'" readonly>
              </mat-form-field>
            </div>

            <div class="col-md-4">
              <mat-form-field>
                <span class="matPrefixDisabled" matPrefix>$&nbsp;</span>
                <input matInput placeholder="Monto Teórico Disponible:"
                  [value]="modParameter.investmentParameterNonSavers.theoreticalAvailableAmount | number: '.2-2'"
                  readonly>
              </mat-form-field>
            </div>

          </div>


          <div class="row mt-5">

            <div class="col-md-4">
              <mat-form-field>
                <input matInput [matDatepicker]="inicioDeCicloPickerNonSavers" placeholder="Inicio De Ciclo:"
                  (dateChange)="setCycleDateNonSavers('starts', $event)" [value]="newRLoanDateNonSavers.startDate">
                <mat-datepicker-toggle matSuffix [for]="inicioDeCicloPickerNonSavers"></mat-datepicker-toggle>
                <mat-datepicker #inicioDeCicloPickerNonSavers></mat-datepicker>
              </mat-form-field>
            </div>

            <div class="col-md-4">
              <mat-form-field>
                <input matInput [matDatepicker]="finDeCicloPickerNonSavers" placeholder="Fin De Ciclo:"
                  (dateChange)="setCycleDateNonSavers('ends', $event)" [value]="newRLoanDateNonSavers.endDate"
                  [min]="newRLoanDateNonSavers.startDate" [disabled]="!newRLoanDateNonSavers.endDate">
                <mat-datepicker-toggle matSuffix [for]="finDeCicloPickerNonSavers"></mat-datepicker-toggle>
                <mat-datepicker #finDeCicloPickerNonSavers [disabled]="!newRLoanDateNonSavers.endDate"></mat-datepicker>
              </mat-form-field>
            </div>

            <div class="col-md-4 bottom-vertically">
              <button class="btn btn-block btn-primary" (click)="addDateNonSavers()">Añadir</button>
            </div>

          </div>

          <div class="my-5 row border-top" *ngIf="modParameter.investmentParameterNonSavers.investmentDates.length > 0">
            <div class="col-md-12">

              <mat-table #investmentsDatesTable class="table"
                [dataSource]="modParameter.investmentParameterNonSavers.investmentDates">

                <ng-container matColumnDef="InicioInversion">
                  <mat-header-cell *matHeaderCellDef> Inicio De Inversion</mat-header-cell>
                  <mat-cell *matCellDef="let element"> {{element.startDate | date: 'mediumDate'}} </mat-cell>
                </ng-container>

                <ng-container matColumnDef="FinInversion">
                  <mat-header-cell *matHeaderCellDef> Fin De Inversion </mat-header-cell>
                  <mat-cell *matCellDef="let element"> {{element.endDate ? (element.endDate | date: 'mediumDate') :
                        ''}}</mat-cell>
                </ng-container>

                <ng-container matColumnDef="active">
                  <mat-header-cell *matHeaderCellDef> Fecha Activa </mat-header-cell>
                  <mat-cell *matCellDef="let element">
                    <mat-checkbox (change)="calculateInvestment()" [(ngModel)]="element.active" [disabled]="false">Fecha
                      Activa</mat-checkbox>
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="delete" class="center-text">
                  <mat-header-cell *matHeaderCellDef><span>Eliminar</span></mat-header-cell>
                  <mat-cell *matCellDef="let index = index">
                    <button mat-icon-button color="warn" (click)="deleteDate(index)">
                      <mat-icon aria-label="Delete">delete_outline</mat-icon>
                    </button>

                  </mat-cell>
                </ng-container>

                <mat-header-row mat-header-row *matHeaderRowDef="displayedLoanDatesColumns"></mat-header-row>
                <mat-row mat-row *matRowDef="let row; columns: displayedLoanDatesColumns;"></mat-row>

              </mat-table>

            </div>
          </div>
        </div>


        <div class="row my-4">

          <div class="col-md-4 offset-md-4">
            <button class="btn btn-block btn-outline-secondary" (click)="cancelEditPeriod()">Cancelar</button>
          </div>

          <div class="col-md-4">
            <button class="btn btn-block btn-primary" (click)="saveEditedPeriod();">Guardar Cambios</button>
          </div>

        </div>

      </div>
      <!-- liberación de prestamos -->
      <div class="p-3" *ngIf="contentLocation.savingParametersIndex == 1">
        <div [ngClass]="{'blocked': disabledLoanListT}" class="row m-5 justify-content-center">
          <!--boton reporte total *ngIf="" -->
          <div class="col-md-4">
            <button style="margin-bottom: 1.25em;" class="btn btn-block btn-primary" [disabled]="disabledLoanListT"
            (click)="reportTotal()"> Reporte Préstamos Liberados </button>
          </div>
        </div>

        <div class="row mt-5">
          <div class="col-md-4">
            <mat-form-field>
              <mat-select placeholder="Tipo de Cuenta:" (selectionChange)="selectedSaving($event)" >
                <mat-option>Seleccione el Tipo</mat-option>
                <mat-option *ngFor="let saver of savingAccount" [value]="saver">
                  {{saver.title}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="col-md-4">
            <mat-form-field>
              <span matPrefix>$&nbsp;</span>
              <input matInput style="width:95%;" placeholder="Ajustes del Banco (Liberación):"
                [ngModel]="bankAdjustmentRelease | number: '1.'"
                (ngModelChange)="bankAdjustmentRelease=currencyInputChanged($event)" appOnlyNumber
                [allowDecimals]="true" type="text" type="string">
            </mat-form-field>
          </div>

          <div class="col-md-4">
            <button class="btn btn-block btn-primary" (click)="procPendingListLoans();">Liberar préstamos en lista de
              espera</button>
          </div>

        </div>
        <!--boton reporte -->
        <div *ngIf="loanList && loanList.length > 0" class="row m-5 justify-content-center">
          <div class="col-md-4">
            <button style="margin-bottom: 1.25em;" class="btn btn-block btn-primary"
            (click)="reporteLoanList()">Préstamos Liberados </button>
          </div>
        </div>

        <div class="row m-5 justify-content-center">
          <div class="alert alert-info" role="alert">
           El monto asignado en Ajustes del Banco (para la liberación), no deben exceder a los <b>$5,000,000.<small>00</small></b> 
          </div>
        </div>

      </div>


    </div>

  </mat-tab>

</mat-tab-group>